/**
 * @module paymentMethod
 * @description A list of payment methods
 */
export const paymentMethod = [
	'card',
	'eft',
	'wallet',
	'cash',
	'voucher',
	'other',
] as const;
export type PaymentMethod = (typeof paymentMethod)[number];
